import React from 'react';
import { Spinner } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import './Loading.scss';

const Loading = () => {
  return (
    <div className="loading-container">
      <Spinner />
    </div>
  );
};

export default Loading;
